module.exports = __webpack_public_path__ + "img/img1.f1ee5ac7.jpg";